export default __webpack_public_path__ + "static/media/themu-copertina-def.1d4aeb58.jpeg";